export enum EResponseErrorCodes {
  ERROR_INVALID_CREDENTIALS = "ERROR_INVALID_CREDENTIALS",
}
